export const GET_TRIP_BY_ID_REQUEST = 'GET_TRIP_BY_ID_REQUEST';
export const GET_TRIP_BY_ID_SUCCESS = 'GET_TRIP_BY_ID_SUCCESS';
export const GET_TRIP_BY_ID_FAIL = 'GET_TRIP_BY_ID_FAIL';
export const SET_TRIP_ROOMS = 'SET_TRIP_ROOMS';
export const SET_BOOKING_TYPE = 'SET_BOOKING_TYPE';